import React from "react"
import { SecondsToHourMins } from "helpers/time-formatter"

const HoursUtilized = ({ timeSpent, duration }) => (
  <div className="exam-card-metadata">
    <i className="clock-icon white-transparent small" />
    <div>
      <span>
        Tempo utilizado <strong>{SecondsToHourMins(timeSpent)}</strong>
      </span>
      <div className="exam-card-metadata-subitem">
        Total: <strong>{SecondsToHourMins(duration)}</strong>
      </div>
    </div>
  </div>
)

export default HoursUtilized
